// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_JEj","col":"styles_col__mlS6B","actions":"styles_actions__1d6dn","conflict":"styles_conflict__3GiO0"};